import React, { Fragment, useState } from "react";
import Typography from "@mui/material/Typography";
import { SNETTextfield, alertTypes } from "shared/dist/components";
import { useDispatch } from "react-redux";
import { organizationActions } from "../../../../../Services/Redux/actionCreators";
import validator from "shared/dist/utils/validator";
import { orgSetupRegionValidationConstraints } from "../../validationConstraints";
import classes from "./AdvanceSettings.module.css";

const AdvanceSettings = ({ show, groups, group, groupIndex, foundInBlockchain }) => {
    const dispatch = useDispatch();
    const [connectionTimeoutValidation, setConnectionTimeoutValidation] = useState();
    const [requestTimeoutValidation, setRequestTimeoutValidation] = useState();
    const [thresholdValidation, setThresholdValidation] = useState();

    const { paymentExpirationThreshold, paymentChannelStorageClient } = group.paymentConfig;
    const { connectionTimeout, requestTimeout } = paymentChannelStorageClient;

    if (!show) {
        return null;
    }

    const handleThresholdChange = (event) => {
        const { value } = event.target;
        const validationThresholdConstraint =
            orgSetupRegionValidationConstraints.groups.array[
                "paymentConfig.paymentExpirationThreshold"
            ];
        handleValidation(value, validationThresholdConstraint, setThresholdValidation);
        const updatedGroups = [...groups];
        updatedGroups[groupIndex] = {
            ...group,
            paymentConfig: {
                ...group.paymentConfig,
                paymentExpirationThreshold: value,
            },
        };
        dispatch(organizationActions.setGroups(updatedGroups));
    };

    const handleValidation = (value, validationConstraint, setterError) => {
        const invalidMessage = validator.single(value, validationConstraint);
        if (invalidMessage) {
            setterError({
                type: alertTypes.ERROR,
                message: invalidMessage[0], // invalidMessage is single-element array
            });
        } else {
            setterError();
        }
    };

    const validationTimeoutParameters = {
        connectionTimeout: {
            validationConstraint:
                orgSetupRegionValidationConstraints.groups.array[
                    "paymentConfig.paymentChannelStorageClient.connectionTimeout"
                ],
            setterErrorFunction: setConnectionTimeoutValidation,
        },
        requestTimeout: {
            validationConstraint:
                orgSetupRegionValidationConstraints.groups.array[
                    "paymentConfig.paymentChannelStorageClient.requestTimeout"
                ],
            setterErrorFunction: setRequestTimeoutValidation,
        },
    };

    const handleTimeoutChange = (event) => {
        const { name, value } = event.target;
        const validationParameters = validationTimeoutParameters[name];
        handleValidation(
            value,
            validationParameters.validationConstraint,
            validationParameters.setterErrorFunction
        );
        const updatedGroups = [...groups];
        updatedGroups[groupIndex] = {
            ...group,
            paymentConfig: {
                ...group.paymentConfig,
                paymentChannelStorageClient: {
                    ...group.paymentConfig.paymentChannelStorageClient,
                    [name]: value,
                },
            },
        };
        dispatch(organizationActions.setGroups(updatedGroups));
    };

    return (
        <Fragment>
            <Typography className={classes.heading}>Advanced Settings</Typography>
            <div className={classes.advancedSettingsContainer}>
                <SNETTextfield
                    name="paymentExpirationThreshold"
                    value={paymentExpirationThreshold}
                    label="Expiration Threashold"
                    onChange={handleThresholdChange}
                    description={
                        <>
                            Time in block numbers for the payment channel to expire. Details &nbsp;
                            <a
                                href="https://dev.singularitynet.io/docs/ai-developers/daemon-channel-storage/"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                here
                            </a>
                        </>
                    }
                    disabled={foundInBlockchain}
                    error={thresholdValidation}
                />
                <SNETTextfield
                    name="connectionTimeout"
                    value={connectionTimeout}
                    label="Client Connection Timeout"
                    onChange={handleTimeoutChange}
                    description="Time period within which a connection between the daemon and the etcd storage server must be established"
                    error={connectionTimeoutValidation}
                />
                <SNETTextfield
                    name="requestTimeout"
                    value={requestTimeout}
                    label="Client Request Timeout"
                    onChange={handleTimeoutChange}
                    description="Time period within which a request needs to be completed by etcd"
                    error={requestTimeoutValidation}
                />
            </div>
        </Fragment>
    );
};

export default AdvanceSettings;
